import type { PublicationCode } from '@/scopes/common/domain/models'
import { FilterType } from '@/scopes/search/quick-search/domain/types'

export type FilterComponent =
  'DestinationFilter'
  | 'DepartureDateFilter'
  | 'DurationFilter'
  | 'ParticipantsFilter'
  | 'TransportTypeFilter'
  | 'DepartureAirportFilter'

const getFilterComponents: Record<string, FilterComponent[]> = {
  SZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  WG: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  BZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  BW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  FS: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  FH: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  FZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  FW: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  DW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  UW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  QZ: ['DestinationFilter', 'DepartureDateFilter', 'DepartureAirportFilter', 'DurationFilter', 'ParticipantsFilter'],
  QW: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  KZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter'],
  KW: ['DestinationFilter', 'DepartureDateFilter', 'TransportTypeFilter', 'DurationFilter', 'ParticipantsFilter'],
  EZ: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter', 'DepartureAirportFilter'],
  BE: ['DestinationFilter', 'DepartureDateFilter', 'DurationFilter', 'ParticipantsFilter', 'DepartureAirportFilter'],
}

export function getFiltersForQuickSearch(publicationCode: PublicationCode): FilterComponent[] {
  return getFilterComponents[publicationCode]
}

const filterComponentToFilterTypeMap: Record<FilterComponent, FilterType> = {
  DestinationFilter: 'Destination',
  DepartureDateFilter: 'DepartureDate',
  DurationFilter: 'Duration',
  ParticipantsFilter: 'Participants',
  TransportTypeFilter: 'TransportType',
  DepartureAirportFilter: 'DepartureAirport',
}

function getFilterTypeForFilterComponent(filterComponent: FilterComponent): FilterType {
  return filterComponentToFilterTypeMap[filterComponent]
}

export function getFilterTypesForQuickSearch(publicationCode: PublicationCode): FilterType[] {
  const filterComponents = getFiltersForQuickSearch(publicationCode) ?? []
  return filterComponents.map(getFilterTypeForFilterComponent)
}
